import { useMutation } from 'react-query';

import {
  useRequest,
  type MutationFunction,
  RunesCallout,
  PrintExtraction,
} from '@frontend/api';

type CreatePrintExtractionRequestParams = {
  fileUuid: string;
  pageNumber: number;
};

export const useCreatePrintExtraction: MutationFunction<
  PrintExtraction,
  RunesCallout,
  [CreatePrintExtractionRequestParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { fileUuid, pageNumber } = params;
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      const urlPath = `/parts/files/${fileUuid}/pages/${pageNumber}/print_extractions`;

      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['createPrintExtraction'],
    },
  );
};
